import { CMS_PAGE_KEY_OPTIONS } from "@/modules/cms/domain/cms-labels";
import { Button, Tabs, TabsList, TabsTrigger } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type CmsSectionsToolbarProps = {
  pageKey: string;
  onPageKeyChange: (pageKey: string) => void;
  canManage: boolean;
  onCreate: () => void;
};

export function CmsSectionsToolbar({
  pageKey,
  onPageKeyChange,
  canManage,
  onCreate,
}: CmsSectionsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ສ່ວນຫນ້າເວັບ</h2>
          <p className="text-muted-foreground">
            ຈັດການ section ເນື້ອຫາ (ຫນ້າເວັບເປັນ static ທີ່ເວັບ).
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Tabs value={pageKey} onValueChange={onPageKeyChange}>
            <TabsList>
              {CMS_PAGE_KEY_OPTIONS.map((p) => (
                <TabsTrigger key={p.value} value={p.value}>
                  {p.label}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
          {canManage && pageKey === "home" && (
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງ Section
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
